export const CONFIG = Object.freeze({
	debug: true,
	apiTestDataConfig: {
		usage: true,
		responseDelay: 200,
		mockError: true,
		errorChances: 0.2,
	},
	Cutwise: {
		Auth: {
			grantType: "password",
			client_id: "10_4kcuxoitbkmc4gc4cwkggw04swg0co48ck0soco8w44w8s0c04",
			client_secret: "2zmg3raap64gc8448co0wcg8kwkswswgscwc00ggco880wwk0k",
			username: "demo",
			password: "UqpY3q3yhLs2xFWt",
		}
	},
});

export default CONFIG;